import React, { useEffect, useState } from "react";
import contactusbanner from "../../../main/assets/images/Images/Contact Us - Images/contact-us-banner.png";
import contactbanner from "../../../main/assets/images/Images/Contact Us - Images/contact_banner.png";
import { MainPageHeader } from "main/components";
import content from "main/helpers/contentHelper.json";
// import { Input } from "main/components/ui-components/Input";
// import { TextArea } from "main/components/ui-components/Textarea";
// import { Button } from "main/components/ui-components/Button";
// import { DropDown } from "main/components/ui-components/Dropdown";
import { Link } from "react-router-dom";

type Props = {};

const Contactus = (props: Props) => {
  // urls
  // redux
  // states
  const [data, setData] = useState<any>(undefined);
  // const [industy, setIndusty] = useState<any>("");
  // const [question, setQuestion] = useState<any>("");
  // const [name, setName] = useState<any>("");
  // const [email, setEmail] = useState<any>("");
  // const [phone, setPhone] = useState<any>("");
  // functions
  // const ContactInfo = () => {
  //   const obj = {
  //     industy,
  //     question,
  //     name,
  //     email,
  //     phone,
  //   };
  //   console.log(obj);
  // };

  // useeffects
  useEffect(() => {
    window.scrollTo(0, 0);
    setData(content);
  }, []);

  return (
    <>
      <div className="contact">
        <MainPageHeader
          mobilebgImage={contactbanner}
          backgroundImage={contactusbanner}
          heading={data ? data?.contact?.headerTitle : ""}
          description={data ? data?.contact?.headerDesc : ""}
          descriptionClass="text-white-color font-family-roboto"
        />
        <div className="container d-flex col-12 section2 gap-20 py-60">
          <div className="row">
            <div className="col-12 col-lg-8">
              <p className="text-primary1 font-30 fonts-800 pb-20 line-35 font-family-roboto footer-content">
                {data ? data?.contact?.sectionTitle : ""}
              </p>
              <p className="fonts-400 font-18 font-family-roboto text-black-90 pb-20 line-24 footer-subcontent">
                {data ? data?.contact?.sectionDesc : ""}
              </p>
              <p className="fonts-400 font-family-roboto font-18 text-black-90 pb-20 line-24 footer-subcontent">
                Reach out directly via email at:{" "}
                <a href="mailto:yantrai.coreteam@techmahindra.com">
                  yantrai.coreteam@techmahindra.com
                </a>
              </p>
              <p className="fonts-400 font-family-roboto font-18 text-black-90 pb-20 line-24 footer-subcontent">
                Our team is dedicated to providing timely and thoughtful
                responses to all inquiries. Whether you're seeking more
                information about our services, need support, or want to explore
                potential collaborations, we're here to listen and engage.
              </p>
              <p className="text-primary1 font-family-roboto font-30 fonts-800 pb-20 pt-40 line-35 footer-content">
                Discover More About Us
              </p>
              <p className="fonts-400 font-18 font-family-roboto text-black-90 pb-20 line-24 footer-subcontent">
                Curious to learn more about the vision, team, and technology
                behind Yantr.ai? We invite you to visit our{" "}
                <a href="/about-us">About Us</a> page. Delve into our journey,
                understand our ethos, and discover how Yantr.ai is
                revolutionizing the field service management industry through
                innovative AI and ML solutions. Our story is not just about
                technology; it's about the people, dedication, and innovation
                that drive us forward.
              </p>
              <p className="fonts-400 font-18 text-black-90 pb-10 font-family-roboto line-24 pb-80 footer-subcontentP">
                Thank you for considering Yantr.ai. We look forward to
                connecting with you.
              </p>
            </div>
            <div className="col-12 col-lg-4 pr-10">
              <div className="col-md-12 py-20">
                <p className="text-primary1 font-30 font-family-roboto fonts-800 pb-20 footer-content">
                  {data ? data?.contact?.form?.title2 : ""}
                </p>
                <div>
                  <div className="pb-18 d-flex gap-2 flex-row">
                    <img
                      src={"/assets/icons/contact/address.svg"}
                      alt="address"
                    />
                    <p className="ps-3 font-family-roboto text-black-90 font-18 line-24 fonts-400 w-100 footer-subcontent2">
                      {/* {data ? data?.contact?.form?.info?.address : ""} */}
                      <a
                        href="https://www.techmahindra.com/services/business-process-services/bpaas/yantrai/"
                        target="_blank"
                      >
                        Yantr.ai | Tech Mahindra
                      </a>
                    </p>
                  </div>
                  <div className="pb-18 d-flex gap-2 flex-row">
                    <img
                      src={"/assets/icons/contact/email.svg"}
                      alt="address"
                    />
                    <p className="ps-3 text-black-90 font-family-roboto font-18 line-24 fonts-400 footer-subcontent2">
                      <a href="mailto:yantrai.coreteam@techmahindra.com">
                        {data ? data?.contact?.form?.info?.email : ""}
                      </a>
                    </p>
                  </div>
                  <div className="pb-18 d-flex gap-2 flex-row">
                    <img
                      src={"/assets/icons/contact/linkedin.svg"}
                      alt="address"
                    />
                    <Link
                      to={"https://in.linkedin.com/company/tech-mahindra"}
                      target="_blank"
                    >
                      <p className="ps-3 font-family-roboto text-black-90 font-18 line-24 fonts-400 footer-subcontent2">
                        {data ? data?.contact?.form?.info?.linkedin : ""}
                      </p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="form ro pt-20 row"> */}
            {/* 
            <div className="col-md-6 py-20">
              <p className="text-primary1 font-34 fonts-400 pb-10">
                {data ? data?.contact?.form?.title : ""}
              </p>
              <div className="py-10">
                <DropDown
                  value={industy}
                  label={"Type of Industries *"}
                  onChange={(e: any) => {
                    console.log(e.target.value, "e.target.value");
                    setIndusty(e.target.value);
                  }}
                  required={true}
                  className={"py-16"}
                >
                  <option value={""} selected>
                    Select
                  </option>
                  <option
                    value="Manufacture"
                    selected={industy === "Manufacture" ? true : false}
                  >
                    Manufacture
                  </option>
                  <option
                    value="Demo"
                    selected={industy === "Demo" ? true : false}
                  >
                    Demo
                  </option>
                </DropDown>
              </div>
              <div className="py-10">
                <TextArea
                  rows={5}
                  required={true}
                  label={"Questions & Comment *"}
                  labelClass="text-black-90 font-18 fonts-400"
                  placeholder=""
                  onChange={(e: any) => {
                    setQuestion(e.target.value);
                  }}
                />
              </div>
              <div className="py-10">
                <Input
                  label={"Full Name *"}
                  labelClass="text-black-90 font-18 fonts-400"
                  placeholder=""
                  type={"text"}
                  inputClass="py-16 w-100"
                  onChange={(e: any) => {
                    setName(e.target.value);
                  }}
                  required={true}
                />
              </div>
              <div className="py-10">
                <Input
                  label={"Email ID *"}
                  labelClass="text-black-90 font-18 fonts-400"
                  placeholder=""
                  type={"email"}
                  inputClass="py-16 w-100"
                  onChange={(e: any) => {
                    setEmail(e.target.value);
                  }}
                  required={true}
                />
              </div>
              <div className="py-10">
                <Input
                  label={"Phone *"}
                  labelClass="text-black-90 font-18 fonts-400"
                  placeholder=""
                  type={"number"}
                  inputClass="py-16 w-100"
                  onChange={(e: any) => {
                    setPhone(e.target.value);
                  }}
                  required={true}
                />
              </div>
              <div className="d-flex justify-content-end pt-25">
                <Button
                  className="py-2 px-5 font-16 fonts-500 text-white"
                  onClick={() => ContactInfo()}
                >
                  {"Submit"}
                </Button>
              </div>
             </div>
             </div>
             */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Contactus;
